import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavDropdown } from 'app/shared/layout/menus/menu-components';
import React from 'react';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { Button, Col } from 'reactstrap';

export const PlaceForms = ({ name, type, saveEntity, placeList, setName, setType }) => {
  return (
    <NavDropdown id={placeList ? 'drop-sub-options-company-search' : 'drop-sub-options-company-search-actived'} name="Configurações" align direction="up">
      <Col
        md={12}
        style={{
          overflowY: 'auto',
          maxHeight: '47vh',
          padding: '20px',
          width: '300px',
          maxWidth: '55vw',
        }}
      >
        <ValidatedForm onSubmit={saveEntity}>
          <ValidatedField
            label={translate('fleetSenseApp.place.name')}
            id="place-name"
            name="name"
            data-cy="name"
            type="text"
            defaultValue={name}
            onChange={event => setName(event.target.value)}
            required
          />
          <ValidatedField
            label={translate('fleetSenseApp.place.type')}
            id="place-type"
            name="type"
            data-cy="type"
            type="select"
            defaultValue={type}
            onChange={event => setType(event.target.value)}
          >
            <option value="REPAIR_SHOP">{translate('fleetSenseApp.PlaceTypeEnum.REPAIR_SHOP')}</option>
          </ValidatedField>
          {/* <ValidatedField
            label={translate('fleetSenseApp.place.approved')}
            id="place-approved"
            name="approved"
            data-cy="approved"
            check
            type="checkbox"
            defaultChecked={isActivated}
            onChange={event => {
              event.preventDefault();
              setIsActivated(event.target.checked);
            }}
          /> */}
          <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit">
            <FontAwesomeIcon icon="save" />
            &nbsp;
            <Translate contentKey="entity.action.save">Salvar</Translate>
          </Button>
        </ValidatedForm>
      </Col>
    </NavDropdown>
  );
};
